module.exports = __webpack_public_path__ + "static/media/Steve Thompson Headshot_1620909835174.4f1c3b5c.jpeg";